import { Prop, Component, Vue } from 'vue-property-decorator';


@Component({
filters:{
        trim: function(string: string) {
            if (string.length > 15)
            {
                return string.substring(0, 22) + '...';
            }else{
                return string;
            }
          }
    
}
})
export default class OrderList extends Vue{
    public orderDetails: any = []
    constructor(){
        super();
    }

    listenHandler(res:any): void{
        console.log("reached inside listener");
        console.log(this.orderDetails);
    }
    
    mounted(): void {
        this.orderDetails = this.$store.getters.getOrderDetails;
        let orderDetail = JSON.parse(<any>localStorage.getItem("orderDetails"));
        console.log('ddd = ',orderDetail);
        if(orderDetail){
            console.log("hello");
                this.orderDetails = orderDetail;
        }
        console.log(this.orderDetails);
    }

    forceDownload(url:any, fileName:any){
        console.log('url - ',url);
        console.log('fileName - ',fileName)
        var xhr = new XMLHttpRequest();
        xhr.open("GET", url, true);
        xhr.responseType = "blob";
        xhr.onload = function(){
            var urlCreator = window.URL || (window as any).webkitURL;
            var imageUrl = urlCreator.createObjectURL(this.response);
            var tag = document.createElement('a');
            tag.href = imageUrl;
            tag.download = fileName;
            document.body.appendChild(tag);
            tag.click();
            document.body.removeChild(tag);
        }
        xhr.send();
    }
}